var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _path6, _g, _path7, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _circle, _ellipse8, _path8, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNightBirdIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8836_16625",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -2,
    width: 82,
    height: 82
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.700195 4.42178C-0.700195 1.11386 1.98141 -1.56775 5.28934 -1.56775H74.3993C77.7072 -1.56775 80.3888 1.11386 80.3888 4.42178V45.9237C80.3888 48.2917 78.4692 50.2114 76.1012 50.2114C73.7332 50.2114 71.8136 52.131 71.8136 54.499V59.0137C71.8136 61.1549 70.6706 63.1331 68.8157 64.2026L42.838 79.1801C40.9853 80.2483 38.7037 80.2476 36.8517 79.1784L10.9121 64.2032C9.05881 63.1333 7.91715 61.1559 7.91715 59.016V54.52C7.91715 52.1404 5.98809 50.2114 3.60848 50.2114C1.22886 50.2114 -0.700195 48.2823 -0.700195 45.9027V4.42178Z",
    fill: "#FCCE2C"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8836_16625)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0593 20.0068L50.2868 29.6515L44.1488 22.3763L51.6872 18.8373C52.4571 18.4759 53.2942 19.1894 53.0593 20.0068Z",
    fill: "#6236BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7661 12.4488L23.9937 22.0935L33.0581 19.1884L28.5497 12.1864C28.0893 11.4714 27.0011 11.6315 26.7661 12.4488Z",
    fill: "#6236BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7619 45.4538C53.2227 37.4747 40.3889 43.4954 35.9403 47.9001L56.4415 54.3866C56.468 54.0602 63.0034 49.2582 65.7963 47.22C66.4077 46.7738 66.4006 45.8602 65.7619 45.4538Z",
    fill: "#6236BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78912 18.0068C22.6379 24.8548 30.9991 43.9335 31.9447 52.4889L5.19962 35.6916C5.44894 35.3838 2.57461 23.9024 1.40812 19.2957C1.19694 18.4617 1.97585 17.7262 2.78912 18.0068Z",
    fill: "#6236BD"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.3165,
    cy: 23.7681,
    rx: 18.3165,
    ry: 23.7681,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 57.0696 22.6483)",
    fill: "#8D61E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8836_16625",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 17,
    width: 38,
    height: 47
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.3165,
    cy: 23.7681,
    rx: 18.3165,
    ry: 23.7681,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 57.0696 22.6483)",
    fill: "#AD8873"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8836_16625)"
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.2672,
    cy: 23.4863,
    rx: 18.2672,
    ry: 23.4863,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 62.4629 25.7988)",
    fill: "#D7C7F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8836_16625",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 12,
    width: 42,
    height: 33
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6608 44.4003C35.8028 43.3328 45.3772 40.4071 51.3872 42.1347L57.1516 22.0814L22.1815 12.0292L16.3705 32.2448C23.1178 34.1843 29.0507 41.3541 30.9728 43.8794C31.3663 44.3964 32.0456 44.6093 32.6608 44.4003Z",
    fill: "#86D1F1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8836_16625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6608 44.4003C35.8028 43.3328 45.3772 40.4071 51.3872 42.1347L57.1516 22.0814L22.1815 12.0292L16.3705 32.2448C23.1178 34.1843 29.0507 41.3541 30.9728 43.8794C31.3663 44.3964 32.0456 44.6093 32.6608 44.4003Z",
    fill: "#6236BD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.2672,
    cy: 23.4863,
    rx: 18.2672,
    ry: 23.4863,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 62.5908 23.746)",
    fill: "#6236BD"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8686 37.6326L38.8937 34.603L39.8332 31.3348L31.8527 29.0405L30.9133 32.3087L32.7439 37.0269C33.0762 37.8833 34.1347 38.1851 34.8686 37.6326Z",
    fill: "#E37230"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.00994,
    cy: 6.00994,
    rx: 6.00994,
    ry: 6.00994,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 49.0398 27.8938)",
    fill: "#AD8873"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.88879,
    cy: 3.88879,
    rx: 3.88879,
    ry: 3.88879,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 46.415 29.3464)",
    fill: "#FCCE2C"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26257,
    cy: 2.26257,
    rx: 2.26257,
    ry: 2.26257,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 45.6753 29.7559)",
    fill: "#1D262D"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.00994,
    cy: 6.00994,
    rx: 6.00994,
    ry: 6.00994,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 37.4885 24.5731)",
    fill: "#AD8873"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.88879,
    cy: 3.88879,
    r: 3.88879,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 34.864 26.0255)",
    fill: "#FCCE2C"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26257,
    cy: 2.26257,
    rx: 2.26257,
    ry: 2.26257,
    transform: "matrix(-0.961081 -0.276268 -0.276268 0.961081 34.1238 26.4353)",
    fill: "#1D262D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_8836_16625",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 0,
    width: 23,
    height: 26
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9332 20.7821C75.2286 20.9898 70.5973 18.5444 68.2323 14.1126C65.9095 9.76007 66.3953 4.65809 69.0579 0.884292C67.2823 0.979843 65.4989 1.45575 63.8266 2.34817C57.7053 5.61481 55.3912 13.2252 58.6578 19.3465C61.9244 25.4678 69.5348 27.7819 75.6561 24.5153C77.4072 23.5808 78.8467 22.2909 79.9332 20.7821Z",
    fill: "#FCCE2C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_8836_16625)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9332 20.7821C75.2286 20.9898 70.5973 18.5444 68.2323 14.1126C65.9095 9.76007 66.3953 4.65809 69.0579 0.884292C67.2823 0.979843 65.4989 1.45575 63.8266 2.34817C57.7053 5.61481 55.3912 13.2252 58.6578 19.3465C61.9244 25.4678 69.5348 27.7819 75.6561 24.5153C77.4072 23.5808 78.8467 22.2909 79.9332 20.7821Z",
    fill: "#E8BF2B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5311 19.1454C77.8266 19.3531 73.1954 16.9076 70.8305 12.476C68.5077 8.12342 68.9935 3.02147 71.6561 -0.752318C69.8804 -0.656799 68.0968 -0.180892 66.4245 0.711572C60.3032 3.97821 57.9891 11.5886 61.2557 17.7099C64.5223 23.8312 72.1327 26.1453 78.254 22.8787C80.0051 21.9442 81.4447 20.6543 82.5311 19.1454Z",
    fill: "#FCCE2C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightBirdIcon);
export default __webpack_public_path__ + "static/media/night-bird-icon.0e9c56d4a08a409bbe910c1148d8a14a.svg";
export { ForwardRef as ReactComponent };